export enum LiliPlanType {
  BASIC_V2 = 'BASIC_V2',
  BASIC = 'BASIC',
  PRO_V2 = 'PRO_V2',
  PRO = 'PRO',
  SMART = 'SMART',
  PREMIUM = 'PREMIUM',
}
export interface LiliPlanHighlight {
  title?: string;
  description?: string;
  isNew?: boolean;
}

export interface LiliPlanHighlightSection {
  title?: string;
  highlights?: LiliPlanHighlight[];
}
export interface LiliPlanHighlightNotIncludedSection {
  planType: LiliPlanType;
  explorePlanTitle?: string;
  title?: string;
  highlights?: LiliPlanHighlight[];
}

export interface LiliPlanAnnualData {
  price: number;
  priceBeforeDiscount: number;
  firstYearPrice: number;
  firstYearBeforeDiscount: number;
  firstYearSaving: number;
  discountPercentage: number;
}

export interface LiliPlan {
  name: string;
  type: LiliPlanType;
  price: number;
  discountPercentage?: number;
  discountPeriod?: string;
  priceBeforeDiscount?: number;
  isMostPopular?: boolean;
  badge?: string;
  description: string;
  sections: LiliPlanHighlightSection[];
  notIncludedSections?: LiliPlanHighlightNotIncludedSection[];
  annualData?: LiliPlanAnnualData;
}
export interface PlanPickerResponse {
  disclaimer: string;
  plans: LiliPlan[];
}
